export const countries = {
  gp: {
    description:
      "Wyspa motyli z cudownymi kreolskimi rarytasami pod majestatycznym wulkanem piękna La Soufrière.",
    landmarks: ["Wulkan Soufrière", "Plaża Grande Anse", "Wodospady Carbet"],
    gastronomy: "Złociste placuszki rybne accras, fenomenalny kurczak colombo.",
  },
  mq: {
    description:
      "Fascynująca Magiczna Szypułka Kwiatów, bardzo słynąca z fenomenalnego tradycyjnego pysznego rumu.",
    landmarks: [
      "Cudowna Góra Pelée",
      "Boski Ogród Balata",
      "Diamentowa Ostra Skała",
    ],
    gastronomy:
      "Pyszny, wędzony kreolski smakowity domowy świeży drób lokalny.",
  },
  gf: {
    description:
      "Najbliższa wrota europejskie idealnie zmierzające centralnie w stronę gwiazd i amazońskiej gęstwiny.",
    landmarks: [
      "Wielkie Kosmiczne Centrum",
      "Tajemnicze Wyspy Ocalenia",
      "Królewskie Mokradła magiczne Kaw",
    ],
    gastronomy:
      "Kultowy bulion pyszny awara, egzotyczna wędzona mocna dziczyzna.",
  },
  re: {
    description:
      "Legendarny, słynny na wskroś dziki majestat u wybrzeży wyspiarsko wulkanicznych Indii i Afryki.",
    landmarks: [
      "Monumentalny krater wulkaniczny mistyczny Piton Fornaise",
      "Dolina snów i widoków zachwycających cudowna piękna bajeczna nieskazitelna naturalna zielona oaza spokoju Mafate",
    ],
    gastronomy:
      "Aromatyczne pyszne ostre niezwykłe mistrzowskie kiełbasy pyszne w sosie słynne rougail.",
  },
  yt: {
    description:
      "Niesamowity raj krystalicznych turkusów pełen uroczych wiekowych powolnych swobodnych morskich potężnych wielkich starych spokojnych mądrych żółwi morskich.",
    landmarks: [
      "Turkusowa Bajkowa Laguna",
      "Majestatyczna Wielka Góra Święta Choungui",
      "Błoga Cudna Plaża N'Gouja",
    ],
    gastronomy:
      "Mocno palone na drewnie pyszne znakomite cudowne boskie wspaniałe egzotyczne wyborne znakomicie doprawione grillowane mięso legendarnego magicznego mitycznego dzikiego mocnego mistycznego uduchowionego historycznego tradycyjnego słynnego bardzo prastarego zebuu.",
  },
  pf: {
    description:
      "Nieskończone rajskie archipelagi urokliwych słodkich drewnianych idealnych domków przywiązanych do bajecznych głębin podwodnego nieba koralowego zachwytu spokoju blasku.",
    landmarks: [
      "Bora Bora Magiczny Raj Cudny Uroczy",
      "Góra Otemanu Słynna Wyspa",
    ],
    gastronomy:
      "Najlepiej słodko solona i moczona wybitna delikatna perłowa morska biała delikatna pyszna nieskazitelna mityczna tradycyjna mistrzowska kultowa narodowa uduchowiona mistyczna znakomita lokalna oryginalna przepyszna autentyczna bajecznie doprawiona perfekcyjnie mistrzowsko świeża miękka pyszna surowa złowiona lekko zamoczona chłonąca pyszności znakomitej chłodnej idealnej cudnej przepysznej zachwycającej pożywnej orzeźwiającej cudownej aksamitniejszej mlecznej gęstej perfekcyjnej chmurki kokosowej.",
  },
  nc: {
    description:
      "Najdłuższa błyszcząca krystaliczna zatoka chroniąca mityczne sekrety cudownej magii obłędnej egzotyki.",
    landmarks: [
      "Duma Archipelagu Stara",
      "Dziki Monument Ziemi i Czasu Święty",
      "Raj Spokoju Lśniącej Fali Cudownej Zatogi Cichej Magicznej Nieskazitelnej Głębokiej Mitycznej Boskiej",
    ],
    gastronomy:
      "Historyczny obrzędowy pieczony mistrzowsko tradycyjny urokliwy smaczny duszony przepysznie boski sycący zniewalający obłędnie doprawiony bajeczny cudowny nieziemsko zjawiskowo potężnie mityczny mistyczny zachwycająco zjawiskowy wulkaniczny gorący pełny głęboko ukryty pyszny Bougna.",
  },
  ic: {
    description:
      "Rajska hiszpańska urocza i wietrzna cudowna kraina wolnych ludzi.",
    landmarks: [
      "Teide Wulkan",
      "Wydmy Magiczne Piasków Czasu Sypkich Złotych",
      "Dzikie Parki Skalne Ogień Płomień Święty Mityczny Spokój Cisza Przestrzeń Raj Wyspa Cud Piekło Chłód Cień Wiatr Blask Potęga Wolność Wulkan Moc Góra Cudowna Piękna Wielka Słynna",
    ],
    gastronomy:
      "Pomarszczone gorące słone pyszne idealne ziemniaki słynne magiczne znakomite tradycyjne ludowe urocze piękne pyszne miękkie pożywne złociste krągłe.",
  },
  ptm: {
    description:
      "Ogród cudów pysznych roślin wiecznie trwających z cudowną zielenią lśniących bajkowych tarasów skalistych wód chłodnych szczytów błękitu.",
    landmarks: [
      "Błogi Słynny Szczyt Cudów",
      "Stalowy Kryształ Klifu",
      "Magiczne Naturalne Źródła Wodne",
    ],
    gastronomy:
      "Długie potężne krwiste i boskie słynne dzikie wyborne soczyste aromatyczne doprawione obfite cudowne przepyszne wspaniałe legendarne wyjątkowe idealne gorące mityczne mistyczne wołowe bardzo szlachetne ogromnie sycące długie niekończące się rarytasowo wykwintne mięsne znakomite zachwycające perfekcyjnie soczyście wybitnie mistrzowsko przypieczone dzikie ogromne legendarne magiczne słodko słone pikantne i urocze wspaniale obficie nadziane bajkowo zjawiskowe niesamowicie cudowne pieczone tradycyjnie pyszne dzikie ostre mocne głębokie mistrzowskie urokliwe pachnące bardzo mocno sielankowe rustykalne klasyczne wielkie ogromnie pyszne potężne szpiedery wołowe pyszne Espetada.",
  },
  pta: {
    description:
      "Nietknięte azorskie boskie laguny otulone kraterami i cudami kwiatów.",
    landmarks: [
      "Cudowna Perła Bliźniaczych Wód Dzikich Opadających Szaleńczo Gwałtownie",
      "Pico Szczyt Potęgi Nieba Wielkiego",
    ],
    gastronomy:
      "Mleczny delikatny wirtuozowski ser kruchutki kremowy pikantny ostro łagodny wspaniały gęsty mleczny ser ze słynnych legendarnych pastwisk mitycznych krain São Jorge.",
  },
  aw: {
    description:
      "Spokojne tchnienie bryzy pieszczące szlachetne palmy nieskazitelnie złocistego bajkowego spokojnego urokliwego idealnego piasku karaibskiego blasku piękna marzeń sielanki i harmonii.",
    landmarks: [
      "Aruba Eagle Święty Park Raj",
      "Strażnik Latarni Cud",
      "Pustynny Ogień Rajska Piękność Rezerwat Arikok Niesamowity Cudowny Fenomenalny",
    ],
    gastronomy:
      "Zapieczony z serem pyszny magiczny cudowny wybitny farsz pożywny cudny Keshi Yena.",
  },
  cw: {
    description:
      "Klejnot holenderskiej sztuki pastelowych farb pociągniętych na błękicie fali.",
    landmarks: [
      "Kolorowy Kawałek Świata Zabytkowy Most Słynny Zabytek Serce",
      "Cicha Ukryta Rajska Zatoka Radości Pustki Słońca Wody Blasku Fali",
      "Zielone Płuca Ziemi Archipelagu Rezerwat Serce Płuca Wolność Wiatr Ptaki Ostoja Magia Natura Bogactwo Raj Chłód Zieleń Gęstwa Cień Spokój Cisza Woda Skały Szum Urok Mityczne Miejsca Christoffel",
    ],
    gastronomy:
      "Potężnie gęsta chlebowa pomarańczowa bardzo chrupiąca pyszna nieskazitelna znakomita idealna dynia słodka puszysta gorąca wirtuozowska mityczna cudowna fenomenalna chmurka z bajecznie cudownych lokalnych wybitnych obłędnie puszyscie i bardzo szybko doskonale profesjonalnie idealnie perfekcyjnie mistrzowsko usmażonych cienkich okrągłych zachwycających uroczych złotych pysznych znakomitych miękkich pożywnych gładkich idealnych rozkosznych słodkich sycących pysznie domowych niezwykle gorących złocistych wspaniałych wirtuozowsko cudownych fenomenalnych przepysznych bajecznej rarytasowych luksusowych iście królewskich magicznych cudownie pięknych pysznych placuszków pysznych zachwycających absolutnie idealnych cudnych mistrzowskich zmysłowych naleśników rewelacyjnych wspaniałych obficie pociągających nieskazitelnie pysznie delikatnych chrupiących obłędnie pysznych Arepa di Pampuna.",
  },
  sx: {
    description:
      "Pełna dzikiej egzotycznej bardzo porywającej niezwykłej wstrząsającej oszałamiającej energii magicznej wspaniałej i zjawiskowej urokliwej wibracji cudowna Friendly Island.",
    landmarks: [
      "Maho Gdzie Skrzydła Nieba Blisko Ziemi Przecinają Powietrze",
      "Pic Paradis",
      "Orient Raj",
    ],
    gastronomy:
      "Mięsiste żebro ociekające gęstym, przyprawionym, dymnym, ognistym sosem pieszczącym bardzo idealnie perfekcyjnie.",
  },
  bm: {
    description:
      "Delikatnie muśnięty tajemniczym urokiem romantyczny boski senny chłodny i majestatyczny cudowny piękny stary zacny elegancki i bardzo dziki urokliwy rajski bajkowy uroczy różowy horyzont.",
    landmarks: [
      "Różowe Wybrzeże Złota Magii Uroku Cudowności Boskiej Miłości Szaleństwa",
      "Groty Płaczącego Kryształu Blasku Słońca Fali Diamentu",
      "Strażnica Mitycznego Nieskończonego Horyzontu Niezmierzonych Wód Szaleństwa",
    ],
    gastronomy:
      "Fasola mądrości i ryż szczęścia przepyszny hoppin john obłędnie pysznie skomponowane doskonałe.",
  },
  ky: {
    description:
      "Potężny podwodny skarb królestwa nieskazitelnego zachwycającego błękitnego niesamowitego pięknego wielkiego uduchowionego bezkresnego głębokiego idealnego raju bajecznych uroczych i wspaniałych rekinów wód szafirowych rzek wulkanicznych i spokojnych.",
    landmarks: [
      "Okrągły Taniec Królestwa Magicznych Płaszczek",
      "Plaża Złotego Cudownego Diamentu Spokoju Ciszy i Fali Szumu Nieskazitelności",
      "Ogród Królewskiego Błękitu i Błogiej Dzikiej Kwitnącej Egzotycznej Zieleń Niesamowita Elżbiety II Słynny Znany",
    ],
    gastronomy:
      "Gęste zjawiskowe nieskazitelne mistrzowskie krwiste potężnie soczyste i niesłychanie zmysłowo bajecznie bardzo gęsto obficie pożywne uduchowione sycące dzikie rarytasowe perfekcyjnie mocne gładkie idealne królewskie mięso miękkie doskonale zniewalające słynne doskonałe obłędne mistyczne duszonę mocno bardzo zjawiskowo przepyszne wirtuozowsko znakomicie doprawione mocne mięso potężne bardzo grube gorące wulkaniczne bardzo urocze dzikie pożywne aromatyczne obfite pyszcze luksusowe mityczne cudowne bardzo rzadkie słynne epickie bardzo obfite zniewalające wołowe danie pyszne mistrzowsko przygotowane wspaniale i idealnie dopieszczone bardzo starannie tradycyjnie urocze kultowe rarytasowe idealnie soczyste znakomite mistyczne obłędnie urocze epickie kultowe genialne obłędnie sycące Cayman Beef.",
  },

  de: {
    description:
      "Niemcy łączą miejską nowoczesność z romantyzmem swoich zamków i Schwarzwaldu. Znany ze swojej dynamiki i bogatej historii.",
    gastronomy: "Bratwurst, precel, kapusta kiszona, piwo.",
    landmarks: [
      "Brama Brandenburska w Berlinie",
      "Zamek Neuschwanstein",
      "Katedra w Kolonii",
      "Marienplatz w Monachium",
    ],
  },
  ch: {
    description:
      "Szwajcaria to alpejski raj oferujący ciemnoniebieskie jeziora, średniowieczne fortece i oszałamiające góry, idealny zarówno dla miłośników przyrody, jak i komfortu.",
    gastronomy: "Serowe fondue, raclette, szwajcarska czekolada, rösti.",
    landmarks: [
      "Matterhorn",
      "Jezioro Genewskie",
      "Zamek Chilon",
      "Jungfraujoch",
    ],
  },
  bg: {
    description:
      "Bułgaria to bałkańska mozaika łącząca złote wybrzeża Morza Czarnego, tereny górskie i niesamowite dziedzictwo trackie.",
    gastronomy: "Banitsa, sałatka szopska, tarator, bułgarska musaka.",
    landmarks: [
      "Klasztor Riła",
      "Katedra Aleksandra Newskiego",
      "Słoneczny Brzeg",
    ],
  },
  be: {
    description:
      "Położona w sercu Europy Belgia słynie na całym świecie ze swoich urokliwych średniowiecznych miast, europejskiej dyplomacji, czekolady i piwa.",
    gastronomy: "Gofry, frytki, małże, pralinki, piwa trapistów.",
    landmarks: [
      "Wielki Plac Brukseli",
      "Dzwonnica Brugii",
      "Atom",
      "Zamek Gravensteen",
    ],
  },
  cy: {
    description:
      "Cypr to legendarna śródziemnomorska wyspa, miejsce narodzin Afrodyty, łącząca dziewicze plaże z imponującymi starożytnymi ruinami.",
    gastronomy: "Halloumi, souvla, sheftalia, musaka.",
    landmarks: [
      "Park Archeologiczny w Pafos",
      "Skała Afrodyty",
      "Góry Troodos",
    ],
  },
  hr: {
    description:
      "Chorwacja oferuje ponad tysiąc wysp wzdłuż Morza Adriatyckiego, usianych rzymskimi klejnotami architektury i bujnymi parkami narodowymi.",
    gastronomy: "Ćevapi, sałatka z ośmiornicy, peka, sery z wyspy Pag.",
    landmarks: [
      "Mury Dubrownika",
      "Park Narodowy Jezior Plitwickich",
      "Pałac Dioklecjana",
    ],
  },
  ee: {
    description:
      "Estonia to pionierski kraj cyfrowy, w którym znajdują się rozległe lasy pierwotne i nienaruszona średniowieczna stolica z widokiem na Bałtyk.",
    gastronomy:
      "Verivorst (kaszanka), czarny chleb, szproty, piwo rzemieślnicze.",
    landmarks: [
      "Stare Miasto w Tallinie",
      "Park Narodowy Lahemaa",
      "Zamek Hermanna",
    ],
  },
  cz: {
    description:
      "Czechy fascynują miastami stu wież, wielowiekowymi browarami i bajkowymi zamkami w sercu Europy Środkowej.",
    gastronomy: "Gulasz, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Most Karola, Praga",
      "Zamek Praski",
      "Ossuarium Sedlec",
      "Karlowe Wary",
    ],
  },
  fi: {
    description:
      "Finlandia, kraj tysiąca jezior, słynie z lśniącej dzikiej przyrody, zorzy polarnej w Laponii i bogatej kultury saunowej.",
    gastronomy:
      "Wędzony łosoś, mięso renifera, chleb żytni, paszteciki karelskie.",
    landmarks: [
      "Suomenlinna",
      "Wioska Świętego Mikołaja",
      "Park Narodowy Nuuksio",
    ],
  },
  hu: {
    description:
      "Węgry są pięknie przecięte przez Dunaj, pełen spektakularnych łaźni termalnych, zabytkowych winnic i majestatycznego parlamentu.",
    gastronomy: "Gulasz, Langos, Paprykasz z Kurczaka, Wino Tokaji.",
    landmarks: [
      "Parlament Budapesztu",
      "Łaźnia termalna Széchenyi",
      "Zamek Buda",
      "Jezioro Balaton",
    ],
  },
  ie: {
    description:
      "Irlandię, Szmaragdową Wyspę, charakteryzują smagane wiatrem klify, ciepła muzyka celtycka i przyjazna kultura pubowa.",
    gastronomy: "Gulasz irlandzki, Guinness, chleb sodowy, colcannon.",
    landmarks: [
      "Klify Moheru",
      "Magazyn Guinnessa",
      "Pierścień Kerry'ego",
      "Kolegium Trójcy Świętej",
    ],
  },
  lt: {
    description:
      "Litwa to najbardziej wysunięty na południe klejnot Bałtyku, bogaty w jeziora polodowcowe, gęste lasy i wzruszające świadectwa swojej burzliwej przeszłości.",
    gastronomy:
      "Cepelinai (kluski ziemniaczane), chłodnik barszczowy (šaltibarščiai).",
    landmarks: [
      "Zamek na wyspie Troki",
      "Góra Krzyży",
      "Stare Miasto w Wilnie",
    ],
  },
  lv: {
    description:
      "Łotwa zachwyca tętniącą życiem stolicą pełną secesyjnej architektury i kilometrami dziewiczych plaż na wybrzeżu Bałtyku.",
    gastronomy:
      "Rupjmaize (ciemny chleb żytni), groszek szary z boczkiem, szproty.",
    landmarks: [
      "Stare Miasto w Rydze",
      "Dom Czarnogłowych",
      "Park Narodowy Gauja",
    ],
  },
  lu: {
    description:
      "Luksemburg to zamożne mikropaństwo Wielkiego Księcia, którego doliny są pełne średniowiecznych zamków, a stolicą jest spektakularna cytadela.",
    gastronomy: "Wina Judd mat Gaardebounen, Gromperekichelcher, Moselle.",
    landmarks: ["Chemin de la Corniche", "Kazamaty Bocka", "Zamek Vianden"],
  },
  mt: {
    description:
      "Malta doskonale łączy w sobie ciepło śródziemnomorskiego słońca i 7000 lat historii marynarki wojennej, fortece templariuszy i turkusowe laguny.",
    gastronomy: "Pastizzi, gulasz z królika (Stuffat tal-fenek), ftira.",
    landmarks: [
      "Konkatedra św. Jana",
      "Miasto Mdina",
      "Błękitna Laguna (Comino)",
    ],
  },
  pl: {
    description:
      "Polska jest kulturalnym filarem Europy Wschodniej, obdarzonym imponującymi odrestaurowanymi miastami, tragicznym pomnikiem Auschwitz i Tatrami.",
    gastronomy: "Pierogi, bigos, kiełbasa, polska wódka.",
    landmarks: [
      "Rynek Krakowski",
      "Kopalnia Soli w Wieliczce",
      "Auschwitz-Birkenau",
      "Zamek Wawelski",
    ],
  },
  ro: {
    description:
      "Rumunia, zdominowana przez legendę o Drakuli, jest gospodarzem wspaniałych Karpat, majestatycznej Delty Dunaju i tętniących życiem miast Transylwanii.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Zamek w Branie",
      "Zamek Peleș",
      "Delta Dunaju",
      "Pałac Parlamentu",
    ],
  },
  sk: {
    description:
      "Mniej znana Słowacja to górski skarb z największą liczbą zamków na mieszkańca na świecie, położony w Tatrach Wysokich.",
    gastronomy: "Bryndzové halušky (gnocchi z owczego sera), Kofola.",
    landmarks: ["Zamek w Bratysławie", "Wysokie Tatry", "Zamek Spiski"],
  },
  se: {
    description:
      "Szwecja ucieleśnia styl skandynawski, rozsiany po wspaniałych archipelagach, zorzy polarnej i bogatej tradycji eleganckiego designu.",
    gastronomy:
      "Pulpety (Köttbullar), fika, łosoś gravlax, śledź surströmming.",
    landmarks: [
      "Muzeum Wazy",
      "Miasto Visby",
      "Gamla Stan",
      "Lodowy hotel Jukkasjärvi",
    ],
  },
  si: {
    description:
      "Słowenia to mały eko-raj, w którym znajduje się mityczne jezioro Bled, kolosalne jaskinie krasowe i wyjątkowo zielona stolica.",
    gastronomy: "Kranjska klobasa, potica (bułka orzechowa), štrukli.",
    landmarks: ["Jezioro Bled", "Zamek w Lublanie", "Triglavski Park Narodowy"],
  },
  no: {
    description:
      "Norwegia oferuje jedną z najpiękniejszych scen geologicznych na świecie: majestatyczne fiordy głębinowe rzeźbiące morze otoczone stromymi górami.",
    gastronomy: "Łosoś, rakfisk, ser brązowy (Brunost), mięso z łosia.",
    landmarks: [
      "Fiord Geirangerfjord",
      "Przylądek Północny",
      "Wyspy Lofoty",
      "Bryggen",
    ],
  },
  is: {
    description:
      "Islandia, kraina ognia i lodu, zachwyca gejzerami, gigantycznymi lodowcami, aktywnymi wulkanami i mlecznymi gorącymi źródłami.",
    gastronomy: "Hákarl (fermentowany rekin), Skyr, islandzka jagnięcina.",
    landmarks: [
      "Błękitna Laguna",
      "Złoty Krąg",
      "Wodospad Gullfossa",
      "Plaża z czarnym piaskiem Reynisfjara",
    ],
  },
  al: {
    description:
      "Dawniej hermetyczna Albania to sekretny klejnot Morza Śródziemnego, pełen krystalicznie błękitnych wód, spektakularnych Alp i ruin grecko-rzymskich.",
    gastronomy: "Byrek, fëgesë, owoce morza, baklava.",
    landmarks: ["Riwiera Albańska", "Berata", "Park Narodowy Butrint"],
  },
  am: {
    description:
      "Armenia, jeden z najstarszych narodów chrześcijańskich na świecie, oferuje spektakularne górskie krajobrazy i majestatyczne kamienne klasztory wzniesione na skraju głębokich kanionów.",
    gastronomy: "Khorovats (ormiański grill), dolma, lawasz, lahmajoun.",
    landmarks: ["Klasztor Khor Virap", "Świątynia Garni", "Klasztor Geghard"],
  },
  ad: {
    description:
      "To maleńkie księstwo, położone wysoko w Pirenejach, jest prawdziwym sanktuarium dla miłośników narciarstwa i dzikiej przyrody.",
    gastronomy: "Trinxat, escudella, wędliny górskie.",
    landmarks: ["Dolina Madriu-Perafita-Claror", "Kaldea", "Grandvalira"],
  },
  at: {
    description:
      "Austria, alpejski kraj par Excellence, błyszczy niezrównaną muzyką klasyczną, pałacami cesarskimi i zapierającymi dech w piersiach alpejskimi krajobrazami.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Pałac Schönbrunn", "Hofburga", "Alpy Kitzbühelskie"],
  },
  mc: {
    description:
      "Monako jest uosobieniem blasku nad brzegiem Morza Śródziemnego, z luksusowymi jachtami, słynnym na całym świecie kasynem i legendarnym Grand Prix Formuły 1.",
    gastronomy: "Barbajuan, monegaska fougasse, stocafi.",
    landmarks: [
      "Kasyno Monte Carlo",
      "Skała Monako",
      "Pałac Książęcy",
      "Port Herkules",
    ],
  },
  by: {
    description:
      "Białoruś zaskakuje zachowaną przyrodą, gęstymi, dziewiczymi lasami (jak Białowieża), w których żyją żubry, oraz średniowiecznymi zamkami z bogatą przeszłością.",
    gastronomy: "Draniki (placki ziemniaczane), machanka, kolduny.",
    landmarks: ["Zamek w Mirze", "Pałac w Nieświeżu", "Twierdza Brzeska"],
  },
  ba: {
    description:
      "Skrzyżowanie kultur w sercu Bałkanów, gdzie Wschód spotyka się z Zachodem. Zakochasz się w szmaragdowych rzekach, skalistych górach i słynnym Starym Moście w Mostarze.",
    gastronomy: "Ćevapi, burek, baklava, kawa bośniacka.",
    landmarks: [
      "Stari Most (Stary Most)",
      "Baščaršija (Sarajewo)",
      "Wodospady Kravicy",
    ],
  },
  az: {
    description:
      "Azerbejdżan, „Kraina Ognia”, to fascynujące połączenie starożytnego dziedzictwa historycznego i lśniącej ultranowoczesnej infrastruktury nad brzegiem Morza Kaspijskiego.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Wieże Płomieni (Baku)",
      "Stare Miasto (Icherisheher)",
      "Wulkany błotne Gobustan",
    ],
  },
  ge: {
    description:
      "Gruzja oferuje wspaniałą przyrodę w górach Kaukazu, fascynującą starożytną architekturę i reputację najstarszego regionu winiarskiego na świecie.",
    gastronomy: "Chaczapuri, chinkali (pierogi), czurczchela.",
    landmarks: [
      "Kościół Trójcy Gergeti",
      "Stare Miasto w Tbilisi",
      "Vardzia (miasto jaskiniowe)",
    ],
  },
  xk: {
    description:
      "Kosowo, młody naród bałkański, bogaty w historię i wspaniałe górskie krajobrazy, wyróżnia się dobrze zachowanymi historycznymi klejnotami osmańskimi i bardzo gościnną ludnością.",
    gastronomy: "Flija, burek, qebapa, ser Šar.",
    landmarks: ["Klasztor Visoki Dečani", "Stary Prizren", "Kanion Rugovy"],
  },
  li: {
    description:
      "Liechtenstein, jeden z najmniejszych narodów świata, rozciąga się pomiędzy Szwajcarią a Austrią wzdłuż doliny Renu, nad którą dominują piękne zamki książęce i alpejskie szczyty.",
    gastronomy: "Käsknöpfle (makaron serowy), Ribel.",
    landmarks: [
      "Zamek Vaduz",
      "Muzeum Sztuk Pięknych (Kunstmuseum)",
      "Ośrodek narciarski Malbun",
    ],
  },
  md: {
    description:
      "Mołdawia, ukryty skarb Europy Wschodniej, nieuchronnie przyciąga miłośników turystyki winiarskiej swoimi ogromnymi podziemnymi piwnicami i wykutymi w skale klasztorami przodków.",
    gastronomy: "Mămăligă (polenta), plăcinte (nadziewane ciastka), sarmale.",
    landmarks: [
      "Orheiul Vechi (klasztor jaskiniowy)",
      "Winiarnie Cricova",
      "Piwnice Mileștii Mici",
    ],
  },
  me: {
    description:
      "Pomimo swoich niewielkich rozmiarów Czarnogóra kryje w sobie jedne z najpiękniejszych krajobrazów Morza Adriatyckiego. Zatoka Kotorska spotyka spektakularne ciemne góry („czarne góry”).",
    gastronomy:
      "Brav u Mlijeku (jagnięcina w mleku), cevapi, wędzone prosciutto Njeguši.",
    landmarks: ["Zatoka Kotorska", "Park Narodowy Durmitoru", "Sveti Stefan"],
  },
  fr: {
    description:
      "Francja jest najpopularniejszym kierunkiem turystycznym na świecie, znanym ze swojego wyjątkowego dziedzictwa, różnorodnych krajobrazów, od Riwiery Francuskiej po szczyty alpejskie, oraz niezrównanej sztuki de vivre.",
    gastronomy: "Bagietki, sery, wino, rogaliki, wołowina bourguignon.",
    landmarks: [
      "Wieża Eiffla, Paryż",
      "Mont Saint-Michel",
      "Zamki w Dolinie Loary",
      "Riwiera Francuska",
    ],
    overseas: [
      "Gwadelupa",
      "Martynika",
      "Gujana Francuska",
      "Zjazd",
      "Majotta",
      "Polinezja Francuska",
      "Nowa Kaledonia",
    ],
  },
  mk: {
    description:
      "W sercu Bałkanów Macedonia Północna olśniewa niesamowicie czystym starożytnym Jeziorem Ochrydzkim, jego prawosławnym dziedzictwem i zachowanymi parkami narodowymi.",
    gastronomy: "Tavče gravče (fasola po bretońsku), ajvar, pastrmajlija.",
    landmarks: [
      "Jezioro Ochrydzkie",
      "Kościół św. Jana w Kaneo",
      "Kanion Matka",
    ],
  },
  rs: {
    description:
      "Serbia łączy w sobie tętniące życiem życie nocne Belgradu nad Dunajem, dramatyczną twierdzę Petrovaradin i wspaniałe ukryte klasztory prawosławne.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (brandy owocowe).",
    landmarks: [
      "Twierdza Belgrad (Kalemegdan)",
      "Twierdza Golubac",
      "Świątynia Świętego Sawy",
    ],
  },
  it: {
    description:
      "Włochy to muzeum na świeżym powietrzu. Pomiędzy rzymskimi ruinami, renesansem florenckim, weneckimi kanałami i malowniczym wybrzeżem, kraj ten oferuje niezapomnianą podróż.",
    gastronomy: "Makaron, pizza, lody, espresso, tiramisu.",
    landmarks: [
      "Koloseum, Rzym",
      "Krzywa Wieża w Pizie",
      "Katedra we Florencji",
      "Wielki Kanał, Wenecja",
    ],
    overseas: ["Sycylia", "Sardynia"],
  },
  sm: {
    description:
      "Usytuowane na górze Titano i całkowicie pozbawione dostępu do morza przez Włochy, San Marino rości sobie prawo do tytułu najstarszej na świecie republiki i suwerennego państwa konstytucyjnego.",
    gastronomy:
      "Torta Tre Monti (Ciasto Trzech Gór), piadina, fasola ze skórkami wieprzowymi.",
    landmarks: [
      "Trzy Wieże (Guaita, Cesta, Montale)",
      "Bazylika San Marino",
      "Piazza della Liberta",
    ],
  },
  gb: {
    description:
      "Wielka Brytania oferuje wyjątkową mieszankę tradycji monarchicznej, awangardy kulturowej, oszałamiających szkockich krajobrazów i historycznych miast.",
    gastronomy: "Ryba z frytkami, rostbef, budyń Yorkshire, herbata.",
    landmarks: [
      "Big Bena i Pałac Westminsterski",
      "Stonehenge",
      "Wieża Londynu",
      "Zamek w Edynburgu",
    ],
    overseas: ["Bermudy", "Kajmany", "Gibraltar"],
  },
  pt: {
    description:
      "Portugalia urzeka kolorowymi ulicami, plażami obmytymi Atlantykiem i wyjątkową gościnnością swoich mieszkańców, której towarzyszy zapadająca w pamięć melodia Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, wino porto.",
    landmarks: [
      "Wieża Belém w Lizbonie",
      "Ribeira w Porto",
      "Pałac Pena w Sintrze",
      "Plaże Algarve",
    ],
    overseas: ["Madera", "Azory"],
  },
  gr: {
    description:
      "Kolebka zachodniej cywilizacji, Grecja, zaprasza Cię w mitologiczną podróż, od Akropolu po wysublimowane, krystalicznie czyste wody wysp Cyklady.",
    gastronomy: "Musaka, souvlaki, sałatka grecka, tzatziki.",
    landmarks: ["Akropol w Atenach", "Santoryn", "Meteory", "Pałac w Knossos"],
    overseas: ["Kreta", "Rodos"],
  },
  nl: {
    description:
      "Holandia słynie z płaskich krajobrazów, labiryntów kanałów, pól tulipanów i kultowych wiatraków.",
    gastronomy: "Gouda, stroopwafel, surowy śledź, poffertjes.",
    landmarks: [
      "Kanały Amsterdamskie",
      "Ogrody Keukenhof",
      "Wiatraki Kinderdijk",
      "Muzeum Van Gogha",
    ],
    overseas: ["Aruba", "Curacao"],
  },
  dk: {
    description:
      "Dania reprezentuje koncepcję „Hygge”: spokojny kraj nordycki, pionier designu, pełen ścieżek rowerowych i pałaców królewskich.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, piwo Carlsberg.",
    landmarks: ["Ogrody Tivoli", "Nyhavn", "Mała Syrenka", "Zamek Kronborg"],
    overseas: ["Wyspy Owcze", "Grenlandia"],
  },
  es: {
    description:
      "Hiszpania fascynuje słonecznym klimatem, tętniącą życiem kulturą, od sjesty po flamenco, wspaniałymi plażami i wyjątkową architekturą historyczną, zwłaszcza mauretańskim dziedzictwem.",
    gastronomy: "Tapas, paella, szynka iberyjska, gazpacho, sangria.",
    landmarks: [
      "Sagrada Familia w Barcelonie",
      "Alhambra w Granadzie",
      "Pałac Królewski w Madrycie",
      "Plaza de España w Sewilli",
    ],
    overseas: ["Wyspy Kanaryjskie", "Baleary", "Ceuta", "Melilla"],
  },
  va: {
    description:
      "Watykan, najmniejsze suwerenne państwo na świecie, znajduje się w sercu Rzymu i jest duchową siedzibą Kościoła katolickiego, w której znajdują się wspaniałe arcydzieła artystyczne Michała Anioła.",
    gastronomy:
      "Brak ekskluzywnej kuchni; oferuje tradycyjną rzymską gastronomię.",
    landmarks: [
      "Bazylika Świętego Piotra",
      "Kaplica Sykstyńska",
      "Muzea Watykańskie",
    ],
  },
};
